export default __webpack_public_path__ + "static/media/Crimson_TechLogo.f1b6bfb6.png";